import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";

export default class ConfirmAdditionalCheckInteractor {
  private reportingPeriodService: IReportingPeriodService;

  constructor(reportingPeriodService) {
    this.reportingPeriodService = reportingPeriodService;
  }

  async execute(reportingPeriodId: number, executionId: number) {
    return this.reportingPeriodService.confirmAdditionalCheck(
      reportingPeriodId,
      executionId
    );
  }
}
